import { useCallback, useEffect, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #3450 -- Score Admin's "Tablet marks" dialog data. GET
// /scoresheet/:id/tablet-marks lists each station whose latest snapshot holds a
// saved copy of the sheet, with a per-movement/per-collective diff of the
// newest copy (server vs tablet) and the sheet's version/updatedAt. POST
// /scoresheet/:id/apply-tablet-marks echoes those back so the server can refuse
// when the sheet or snapshot moved since the diff was shown.
export function useTabletMarks(sheetId) {
  const scoreApi = useScoreApi();
  const [state, setState] = useState({ loading: true, error: null, data: null });
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: null, data: null });
    (async () => {
      try {
        const data = unwrap(await scoreApi.scoreSheets.getSheetTabletMarks(sheetId));
        if (!cancelled) setState({ loading: false, error: null, data });
      } catch (error) {
        if (!cancelled) setState({ loading: false, error, data: null });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [scoreApi, sheetId]);

  // Resolves with the updated sheet; rejects with the axios error (the caller
  // maps err.response.data.code to a static message).
  const apply = useCallback(
    async (candidate, note) => {
      const sheet = state.data?.sheet;
      setApplying(true);
      try {
        const body = {
          deviceId: candidate.deviceId,
          scribeSub: candidate.scribeSub,
          snapshotKey: candidate.snapshotKey,
          expectedVersion: sheet.version,
          expectedUpdatedAt: sheet.updatedAt,
        };
        if (note) body.note = note;
        return unwrap(await scoreApi.scoreSheets.applySheetTabletMarks(sheetId, body));
      } finally {
        setApplying(false);
      }
    },
    [scoreApi, sheetId, state.data],
  );

  return { ...state, apply, applying };
}

export default useTabletMarks;
